export const containedAppThemeVersion = "2.1.0";
export function readContainedAppTheme(root = document.documentElement) {
    const styles = getComputedStyle(root);
    const token = (name) => styles.getPropertyValue(name).trim();
    return {
        accent: token("--ss-color-accent"),
        border: token("--ss-color-border"),
        panel: token("--ss-color-surface-raised"),
        panelMuted: token("--ss-color-surface-muted"),
        text: token("--ss-color-text"),
        textMuted: token("--ss-color-text-muted"),
    };
}
